goog.provide("shadow.js.shim.module$ol$layer$Tile");
goog.provide("module$shadow_js_shim_module$ol$layer$Tile");
shadow.js.shim.module$ol$layer$Tile = shadow.js.nativeProvides["ol/layer/Tile"] = shadow$bridge("ol/layer/Tile");
module$shadow_js_shim_module$ol$layer$Tile.default = shadow.js.shim.module$ol$layer$Tile;
